import { AxiosHttpClient } from 'api/axios';
import { useRepruaIndexApi } from 'api/shared_api_hooks';
import { PagingResponse, ID } from 'entities';
import { RepairEstimate, RepairEstimateSearchForm } from 'entities/repair_estimate';
import { IndexApiSet } from 'rac';
import { useEffectSkipFirst } from 'utils/hooks';

export type RepairEstimatesResponse = PagingResponse & {
  repairEstimates: RepairEstimate[];
};

/**
 * 一覧
 */
export type RepairEstimatesIndexApiSet = IndexApiSet<RepairEstimatesResponse> & { execute: () => void };
export function useFetchInstrumentRepairEstimatesApi(
  instrumentId?: ID
): IndexApiSet<RepairEstimatesResponse> & { execute: () => void } {
  const api = useRepruaIndexApi<RepairEstimatesResponse, RepairEstimateSearchForm>(new AxiosHttpClient('user'), {
    initialResponse: { repairEstimates: [], totalCount: 0 },
  });

  const execute = () => {
    const path = `instruments/${instrumentId}/repair_estimates`;
    api.execute(path);
  };

  useEffectSkipFirst(() => {
    execute();
  }, [api.pageSet.page, api.pageSet.perPage, api.orderSet.order, api.orderSet.orderBy]);

  return { ...api, execute };
}
